export default __webpack_public_path__ + "static/media/address_book.daa9843a.svg";